import * as ContactMeta from './ContactMeta.jsx';
import { Blocks as LineItemCellBlocks } from '../common/LineItemCell.jsx';
import { ContainerTypeConfig as LineItemCellTypeConfig, MetaTokens as LineItemCellMetaTokens } from './LineItemCell.jsx';
import * as LineItems from './LineItems.jsx';
import * as Meta from './Meta.jsx';
import Name from '../utility/Name.jsx';
import * as Signature from './Signature.jsx';
import Token from '../utility/Token.jsx';
import * as Totals from './Totals.jsx';
import Utilities from '../utility/Utilities.jsx';

const Blocks = {
    get: (group, data) => [
        {
            id: 'consignmentSeparator',
            dataType: 'separator',
            display: 'Consignment',
            group
        },
        {
            id: Name.Block.Client.ContactMeta,
            component: ContactMeta.Component,
            config: {
                Block: ContactMeta.TypeConfig.panel.block(),
                Style: ContactMeta.TypeConfig.panel.style(),
                Description: ContactMeta.TypeConfig.panel.description(),
                Label: ContactMeta.TypeConfig.panel.label(),
                Value: ContactMeta.TypeConfig.panel.value()
            },
            display: 'Contact Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Consignment.Meta,
            component: Meta.Component,
            config: {
                Block: Meta.TypeConfig.panel.block(),
                Style: Meta.TypeConfig.panel.style(),
                Description: Meta.TypeConfig.panel.description(),
                Label: Meta.TypeConfig.panel.label(),
                Value: Meta.TypeConfig.panel.value()
            },
            display: 'Consignment Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Consignment.Terms,
            blockType: Name.Block.Consignment.Meta,
            component: Meta.Component,
            config: {
                Block: Meta.TypeConfig.panel.block(),
                Style: Meta.TypeConfig.panel.style(),
                Description: Meta.TypeConfig.panel.description(),
                Label: Meta.TypeConfig.panel.label(),
                Value: Meta.TypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Terms}("before":"","after":"")}`, token: Token.Terms }))
            },
            display: 'Consignment Terms',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.List,
            component: LineItems.Component,
            config: {
                Block: LineItems.TypeConfig.panel.block(),
                Style: LineItems.TypeConfig.panel.style(),
                Visibility: LineItems.TypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: LineItemCellTypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Line Items',
            group,
            image: ''
        },
        {
            id: Name.Block.Consignment.Totals,
            component: Totals.Component,
            config: {
                Block: Totals.TypeConfig.panel.block(),
                Style: Totals.TypeConfig.panel.style(),
                Description: Totals.TypeConfig.panel.description(),
                Label: Totals.TypeConfig.panel.label(data),
                Value: Totals.TypeConfig.panel.value(data),
                Visibility: Totals.TypeConfig.panel.visibility()
            },
            display: 'Totals',
            group,
            image: ''
        },
        {
            id: Name.Block.Signature,
            component: Signature.Component,
            config: {
                Block: Signature.TypeConfig.panel.block(),
                Style: Signature.TypeConfig.panel.style(),
                Description: Signature.TypeConfig.panel.description(),
                Label: Signature.TypeConfig.panel.label(),
                Value: Signature.TypeConfig.panel.value()
            },
            display: 'Signature',
            group,
            image: ''
        },
    ]
};
const Content = {
    [Name.Block.Inventory.List]: LineItemCellBlocks
};
const Tokens = {
    get: (id, data) => {
        switch (id) {
            case Name.Block.Client.ContactMeta:
                return ContactMeta.Tokens();
            case Name.Block.Consignment.Meta:
                return Meta.Tokens();
            case Name.Block.Consignment.Totals:
                return Totals.Tokens(data);
            case Name.Block.Inventory.Meta:
                return LineItemCellMetaTokens(data);
            case Name.Block.Signature:
                return Signature.Tokens();
        }
    }
};

export {
    Blocks,
    Content,
    Tokens
}